import {Ticket} from "../models/hotels";
import {clone, findIndex} from "lodash";
import {
    TICKETS_API_ERROR,
    TICKETS_DELETED,
    TICKETS_LOADED, TICKETS_LOADING, TICKETS_SAVE_LOADING, TICKETS_SAVED, TICKETS_UPDATE_NEW,
    TICKETS_UPDATED,
    TicketAction, TICKETS_SHOW_INACTIVE, DELTA_LOADED, DELTA_UPDATE_NEW, DELTA_SAVED, DELTA_UPDATED, DELTA_DELETED
} from "../actions/tickets";
import {TicketPriceDelta} from "../models/order";

export interface TicketsState {
    tickets: Ticket[];
    newTicket?: Ticket;
    loading: boolean;
    saveLoading: boolean;
    errorMessage?: string;
    showInactive: boolean;
    deltas: TicketPriceDelta[];
    newDelta?: TicketPriceDelta;
}

const initialState = (): TicketsState => {
    return {
        loading: false,
        saveLoading: false,
        showInactive: false,
        tickets: [],
        deltas: [],
    };
};

export function ticketsReducer(state: TicketsState = initialState(), action: TicketAction): TicketsState {
    switch (action.type) {
        case TICKETS_LOADING:
            return {
                ...state,
                loading: true,
                errorMessage: null
            } as TicketsState;
        case TICKETS_LOADED:
            return {
                ...state,
                loading: false,
                errorMessage: null,
                tickets: action.tickets,
            } as TicketsState;
        case TICKETS_API_ERROR:
            return {
                ...state,
                loading: false,
                saveLoading: false,
                errorMessage: action.errorMessage
            } as TicketsState;
        case TICKETS_UPDATE_NEW:
            return {
                ...state,
                newTicket: clone(action.newTicket)
            } as TicketsState;

        case TICKETS_SAVE_LOADING:
            return {
                ...state,
                saveLoading: true
            } as TicketsState;

        case TICKETS_SAVED: {
            const tickets = state.tickets;
            tickets.push(action.newTicket);
            return {
                ...state,
                tickets,
                newTicket: null,
                saveLoading: false
            } as TicketsState;
        }

        case TICKETS_UPDATED: {
            const tickets = state.tickets;
            const ix = findIndex(tickets, d => d.id === action.newTicket.id);
            if (ix > -1) {
                tickets.splice(ix, 1, action.newTicket);
            }
            return {
                ...state,
                tickets,
                newTicket: null,
                saveLoading: false
            } as TicketsState;
        }

        case TICKETS_DELETED: {
            const tickets = state.tickets;
            const ix = findIndex(tickets, d => d.id === action.newTicket.id);
            if (ix > -1) {
                tickets.splice(ix, 1);
            }
            return {
                ...state,
                tickets,
                newTicket: null,
                saveLoading: false
            } as TicketsState;
        }

        case TICKETS_SHOW_INACTIVE:
            return {
                ...state,
                showInactive: action.showInactive
            };

        case DELTA_LOADED:
            return {
                ...state,
                loading: false,
                errorMessage: null,
                deltas: action.deltas,
            } as TicketsState;

        case DELTA_UPDATE_NEW:
            return {
                ...state,
                newDelta: clone(action.newDelta)
            } as TicketsState;

        case DELTA_SAVED: {
            const deltas = state.deltas;
            deltas.push(action.newDelta);
            return {
                ...state,
                deltas,
                newDelta: null,
                saveLoading: false
            } as TicketsState;
        }

        case DELTA_UPDATED: {
            const deltas = state.deltas;
            const ix = findIndex(deltas, d => d.id === action.newDelta.id);
            if (ix > -1) {
                deltas.splice(ix, 1, action.newDelta);
            }
            return {
                ...state,
                deltas,
                newDelta: null,
                saveLoading: false
            } as TicketsState;
        }

        case DELTA_DELETED: {
            const deltas = state.deltas;
            const ix = findIndex(deltas, d => d.id === action.newDelta.id);
            if (ix > -1) {
                deltas.splice(ix, 1);
            }
            return {
                ...state,
                deltas,
                newDelta: null,
                saveLoading: false
            } as TicketsState;
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/tickets.ts